import React from 'react';
import { XCircle } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
import { motion } from 'framer-motion';
const failures = ['Los presupuestos en Excel son demasiado rígidos y los abandonas a la primera semana.', 'Intentar "ahorrar lo que sobre" es una trampa, porque por psicología humana, nunca sobra nada.', 'Las fórmulas para "hacerse rico" con criptos o trading son demasiado riesgosas y te generan parálisis por análisis.', 'Esperar a ganar más dinero para empezar no funciona, porque tus gastos suelen subir al mismo ritmo que tu sueldo.'];
export function FailedSolutions() {
  return <AnimatedSection className="py-24 bg-navy-800 relative px-4 sm:px-6 lg:px-8" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-16" data-id="element-3">
          Por qué lo que has intentado{' '}
          <span className="text-slate-400 line-through decoration-red-500/50" data-id="element-4">
            no funcionó
          </span>
        </h2>

        <div className="space-y-6" data-id="element-5">
          {failures.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-navy-900/50 rounded-2xl border border-navy-700/50 hover:border-navy-600 transition-colors" data-id="element-6">
              <XCircle className="w-6 h-6 text-red-400/80 shrink-0 mt-1" data-id="element-7" />
              <p className="text-lg text-slate-300" data-id="element-8">{text}</p>
            </motion.div>)}
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/10 to-transparent" data-id="element-9" />
    </AnimatedSection>;
}